import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  MaintenanceCounterWithPercentage,
  PartType,
  PartTypeDisplayValue,
  PartWithCounterDetails,
} from '../../models/maintenancelogs.model';
import {
  getLeastRemainingUsage,
  getMaintenanceStatusColor,
} from '../../utils/maintenance-counter';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-drone-model-vector-table',
  templateUrl: './drone-model-table.component.html',
  styleUrl: './drone-model-table.component.scss',
  standalone: false,
})
export class DroneModelVectorTableComponent implements OnChanges {
  private static highestCardZIndex = 1;

  @Input() part?: PartWithCounterDetails;
  @Input() modelType: 'vector' | 'scorpion' = 'vector';
  protected readonly PartType = PartType;
  statusIndicator: number = 100;
  displayType: string = '';
  metricsExpanded = false;
  cardZIndex = 1;

  constructor(private translateService: TranslateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['part']) {
      this.metricsExpanded = false;
    }

    if (changes['part']?.currentValue && this.part) {
      this.statusIndicator = getLeastRemainingUsage(this.part.counters);
      this.displayType =
        PartTypeDisplayValue[this.part.partId.partType] ||
        this.translateService.instant('drone.part.unknown');
    }
  }

  toggleMetrics(): void {
    this.metricsExpanded = !this.metricsExpanded;
  }

  bringToFront(): void {
    this.cardZIndex = ++DroneModelVectorTableComponent.highestCardZIndex;
  }

  protected getFormattedCounter(part?: PartWithCounterDetails): string {
    const counter = part?.type.maintenanceCounter;
    if (!counter?.value) {
      return '-';
    }
    const threshold = counter.threshold ? parseFloat(counter.threshold) : 0;
    const unit = counter.unit?.trim() || counter.valueType;

    return threshold
      ? `${counter.value} / ${threshold} ${unit}`
      : `${counter.value} ${unit}`;
  }

  protected formatMetricsValueThreshold(
    mc: MaintenanceCounterWithPercentage,
  ): string {
    const threshold = mc.threshold ? parseFloat(mc.threshold) : 0;
    const unit = mc.unit?.trim() || mc.valueType;

    return threshold
      ? `${mc.value} / ${threshold} ${unit}`
      : `${mc.value} ${unit}`;
  }

  protected formatMetricPercentage(
    counter: MaintenanceCounterWithPercentage,
  ): string | null {
    const percentage = counter.percentage;
    return typeof percentage === 'number' && Number.isFinite(percentage)
      ? `${percentage.toFixed(2)}%`
      : null;
  }

  protected getMetricPercentageColor(
    counter: MaintenanceCounterWithPercentage,
  ): string {
    return getMaintenanceStatusColor(getLeastRemainingUsage([counter]));
  }
}
